import React from "react";
import { useDocumentTitle } from '../../hooks/useDocumentTitle';

const PermitsPage = () => {
    // Set document title
    useDocumentTitle('Strandskydd & bygglov');

    return (
        <div>
            <h1 className="page-title">Strandskydd & bygglov</h1>
            <p>Innehåll kommer visas här</p>
        </div>
    );
};

export default PermitsPage;
